/**
 * Transactions Feature API
 */

import apiClient from '../../../shared/services/apiClient';

export const transactionsAPI = {
  getAll: (params) => apiClient.get('/transactions', { params }),
  getById: (id) => apiClient.get(`/transactions/${id}`),
  getStats: (params) => apiClient.get('/transactions/stats/summary', { params }),
  create: (data) => apiClient.post('/transactions', data),
  update: (id, data) => apiClient.put(`/transactions/${id}`, data),
  delete: (id) => apiClient.delete(`/transactions/${id}`),
  deleteImported: (accountId, businessId) => apiClient.delete('/transactions/imported', {
    params: {
      account_id: accountId,
      ...(businessId ? { business_id: businessId } : {})
    }
  }),
  checkDuplicates: (transactions, account_id) => apiClient.post('/transactions/check-duplicates', { transactions, account_id }),
  bulkImport: (transactions) => apiClient.post('/transactions/bulk-import', { transactions }),
  bulkUpdate: (transactions) => apiClient.put('/transactions/bulk-update', { transactions }),
  getSplits: (id) => apiClient.get(`/transactions/${id}/splits`),
  saveSplits: (id, parts) => apiClient.put(`/transactions/${id}/splits`, { parts }),
  removeSplits: (id) => apiClient.delete(`/transactions/${id}/splits`),
  setDirection: (id, direction) => apiClient.put(`/transactions/${id}/direction`, { direction }),
  directionReview: (params) => apiClient.get('/transactions/direction-review', { params }),
  splitsFor: (ids) => apiClient.get('/transactions/splits', { params: { ids: ids.join(',') } }),
};

export default transactionsAPI;

